// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Created by Inzamam Janjua on 18/05/2023.
 */
.auth-wrapper {
  width: 100%;
  height: 100vh;
  padding: 26px 20px 17px 20px;
}

.gc-auth-leftPanel {
  height: 100%;
  background: #fff url('mesh-gradient-bg.4dcf46c1580a723e.png') no-repeat center center;
  background-size: cover;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.gc-idnty-container {
  padding: 0 80px;
  margin-top: 0;
  width: 100%;
}
.gc-idnty-container p {
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
}

.password-check {
  height: 4px;
  width: 100px;
  background-color: #ccc;
}

.password-strength-container {
  display: flex;
  justify-content: flex-end;
}

.weak-password {
  background-color: #FF6B6B; /* Red color */
}

.medium-password {
  background-color: #FEBD2E; /* Yellow color */
}

.strong-password {
  background-color: #66DE93; /* Green color */
}

/* Weak Password Text Style */
.weak-password-text {
  color: #FF6B6B; /* Red color */
  margin: -15px 0 0 0;
}

/* Medium Password Text Style */
.medium-password-text {
  color: #FEBD2E;
  margin: -12px; /* Yellow color */
}

/* Strong Password Text Style */
.strong-password-text {
  color: #66DE93; /* Green color */
  margin: -15px 0 0 0;
}

.gc-auth-slider {
  padding: 0 56px;
  margin-top: 60px;
}

.password-req {
  font-size: 12px;
  margin-top: 8px;
  display: inline-block;
  line-height: 28px;
}
@media (max-width: 1640px) {
  .password-req {
    line-height: 16px;
  }
}

.gc-exp-title {
  width: 196px;
  height: 56px;
  padding: 16px 13px 16px 16px;
  border-radius: 16px;
  background: rgba(45, 51, 69, 0.1019607843);
  margin-left: 50px;
  margin-bottom: 50px;
  margin-top: 100px;
}

.gc-exp-note {
  border-radius: 24px;
  background: rgba(45, 51, 69, 0.1019607843);
  padding: 35px;
  font-size: 21px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.01em;
  text-align: left;
  color: #0A6ED9;
}

.forcereset-textbox {
  width: 670px;
  background: #fff;
  max-width: 100%;
  padding: 45px;
  border-radius: 10px;
  margin: auto;
}
.forcereset-textbox p {
  color: #1E38A9;
  text-align: center;
  font-size: 22px;
  font-weight: 700;
  line-height: 26px;
  margin-top: 55px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
